// Portfolio.js — Bloco laranja "Você quer publicar sua obra?".
// Layout em camadas (do fundo para o topo):
//   1) Cor de fundo laranja sólido (insigne-orange-alt)
//   2) Padrão FundoLaranja.png TILED por TODA a seção (bg-repeat)
//   3) Gradient overlay topo→base: transparente → laranja sólido
//      (faz o padrão sumir suavemente na base, virando laranja sólido)
//   4) Conteúdo: texto/CTA à esquerda + laptop à direita
//   5) Faixa de transição final: transparente → cor de fundo do site
//      (a seção laranja se dissolve no azul da página antes da próxima seção)
import React, { useState } from "react";
import Mockup from "../../assets/imgs/Site Editora (1).png";
import FundoLaranja from "../../assets/imgs/FundoLaranja.png";
import DownloadPopup from "./DownloadPopup";
import Reveal from "../ui/Reveal";

const PDF_LINK = "https://insigneacademica.com.br/api/get-pdf";

async function downloadPDF(setDownloadMessage, setShowPopup) {
  try {
    setDownloadMessage(
      "Seu download começará em instantes. Verifique sua pasta de downloads."
    );
    setShowPopup(true);
    const r = await fetch(PDF_LINK);
    const blob = await r.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "portfolio.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    setTimeout(() => setShowPopup(false), 3000);
  } catch {
    setDownloadMessage("Ocorreu um erro ao tentar baixar o portfólio.");
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 3000);
  }
}

const Portfolio = () => {
  const [downloadMessage, setDownloadMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  return (
    // Era a única seção da home sem entrada: 460px de laranja que apareciam
    // de uma vez entre duas seções que entram. `Reveal` renderiza a própria
    // <section>, então nenhum elemento novo entra no layout em camadas.
    <Reveal as="section" className="relative bg-insigne-orange-alt overflow-hidden">
      {/* Camada 2: padrão laranja TILED em todo o fundo da seção */}
      <div
        className="absolute inset-0 bg-repeat pointer-events-none mix-blend-soft-light"
        style={{ backgroundImage: `url(${FundoLaranja})`, backgroundSize: "300px" }}
      />

      {/* Camada 3: gradient overlay topo→base (transparente → laranja sólido) */}
      <div className="absolute inset-0 pointer-events-none
                      bg-gradient-to-b from-transparent to-insigne-orange-alt" />

      {/* Camada 4: conteúdo (z-10 — fica acima das camadas 2 e 3) */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 items-stretch max-w-[1400px] mx-auto min-h-[460px]">
        {/* Texto / CTA */}
        <div className="flex flex-col justify-center text-ink-fixed px-6 md:px-16 py-12 md:py-20 text-center md:text-left">
          <h1 className="titulo-display text-[3rem] md:text-[4.6rem] mb-6">
            Você quer publicar<br />sua obra?
          </h1>
          <p className="text-base md:text-lg mb-6">
            Confira o Portfólio completo da Insigne Acadêmica Editora
          </p>
          {/* `hover:scale-105` era o único "cresce no hover" do site; aqui vale
              a inversão do `.btn-solido`, como nos outros CTAs.
              A cor precisa de cuidado: o bloco é laranja nos DOIS temas, então
              o laranja padrão da classe sumiria sobre ele. O navy resolve, mas
              todos os tokens navy clareiam para quase-branco no tema claro — e
              aí o botão (fundo navy-deep + texto branco) desapareceria de novo.
              `.brand-dark` é exatamente a saída que o header e o rodapé usam:
              trava a paleta escura no escopo, e o navy-deep continua navy-deep.
              Nos dois estados lê: em repouso navy sobre laranja; no hover fundo
              branco com o mesmo navy no texto e na borda tracejada. */}
          <button
            onClick={() => downloadPDF(setDownloadMessage, setShowPopup)}
            className="btn-solido brand-dark w-fit mx-auto md:mx-0 px-8 py-3 rounded font-semibold"
            style={{ "--btn-cor": "rgb(var(--c-navy-deep))" }}
          >
            Ver Portfolio
          </button>
        </div>

        {/* Laptop ocupando toda a coluna direita.
            SEM gradient próprio: a faixa de transição da camada 5 já cuida do fade. */}
        <div className="relative hidden md:block min-h-[460px]">
          <img
            src={Mockup}
            alt="Mockup do portfólio Insigne"
            className="absolute inset-0 w-full h-full object-cover object-left"
          />
        </div>
      </div>

      {/* Camada 5: transição final — base laranja desta seção → azul da página.
          z-20 fica acima do conteúdo para fundir TODA a base da seção
          (incluindo a barra inferior do laptop) no azul do site. */}
      <div className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none z-20
                      bg-gradient-to-b from-transparent to-insigne-bg" />

      <DownloadPopup message={downloadMessage} showPopup={showPopup} />
    </Reveal>
  );
};

export default Portfolio;
